import styled from 'styled-components';
import { P, fs, radius, eyebrowLabel, onPhone } from '../theme/tokens';

const control = `
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${P.border};
  border-radius: ${radius.md}px;
  background-color: ${P.white};
  font-family: inherit;
  font-size: ${fs.sm}px;
  color: ${P.ink};
  outline: none;
  transition: border-color 120ms, box-shadow 120ms;

  &:focus {
    border-color: ${P.navy};
    box-shadow: 0 0 0 3px rgba(30, 58, 95, 0.12);
  }
  &:disabled {
    background-color: ${P.gray100};
    cursor: not-allowed;
  }
`;

export const Field = styled.input`
  ${control}
  padding: 10px 13px;
`;

export const TextArea = styled.textarea`
  ${control}
  display: block;
  min-height: 96px;
  padding: 10px 13px;
  line-height: 1.5;
  resize: vertical;
`;

const CHEVRON =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5l5 5 5-5' fill='none' stroke='%23595959' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";

export const Select = styled.select`
  ${control}
  appearance: none;
  min-width: 200px;
  padding: 10px 38px 10px 13px;
  background-image: ${CHEVRON};
  background-repeat: no-repeat;
  background-position: right 14px center;
  background-size: 11px 8px;
  cursor: pointer;
`;

export const Form = styled.div`
  display: grid;
  gap: 12px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  ${onPhone} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FormField = styled.div`
  display: grid;
  gap: 6px;
`;

export const FieldLabel = styled.label`
  display: block;
  ${eyebrowLabel}
`;
